import { useEffect, useState } from 'react'
import { AiOutlineLoading3Quarters } from 'react-icons/ai'
import { BiEnvelope, BiMailSend, BiMap } from 'react-icons/bi'
import { MdOutlineCall } from 'react-icons/md'
import InputCustom from 'src/components/atoms/InputCustom'

import axios from 'axios'
import { toast } from 'react-toastify'
import useSwr from 'swr'

const fether = async url => {
  const response = await axios(url)
  return response.data
}

const RequestList = () => {
  const API = process.env.REACT_APP_API
  const { data } = useSwr(API + '/service', fether)

  const [loading, setLoading] = useState(false)

  const [email, setEmail] = useState('')
  const [name, setName] = useState('')
  const [phone, setPhone] = useState('')
  const [message, setMessage] = useState('')
  const [service, setService] = useState('Produk Angkasa Multimedia Solusi')
  const [address, setAddress] = useState('')

  const [packageList, setPackageList] = useState()
  const [activeBtn, setActiveBtn] = useState('')

  const handleChangeService = item => {
    setService(item.title)
    setActiveBtn(item.title)
  }

  useEffect(() => {
    setPackageList(data)
    setActiveBtn(data && data[0]?.title)
  }, [data])

  const handleSubmit = async () => {
    const dataForm = {
      email,
      name,
      phone,
      message: message + ' - ' + service,
      address
    }

    if (!email) return toast.error('Silahkan masukkan email Anda!')
    if (!name) return toast.error('Silahkan masukkan nama Anda!')
    if (!phone) return toast.error('Silahkan masukkan telepon Anda!')
    if (!message) return toast.error('Silahkan masukkan Pesan!')
    if (!address) return toast.error('Silahkan masukkan Alamat!')

    try {
      setLoading(true)
      const response = await axios({
        method: 'POST',
        url: process.env.REACT_APP_API + '/send-email',
        data: dataForm
      })

      if (response.data.status === 200) {
        toast.success(
          'Terimakasih. Pesan telah terkirim, Team Angkasa Multimedia Solusi akan segera menghubungi anda'
        )
        setEmail('')
        setName('')
        setPhone('')
        setMessage('')
        setService('')
        setAddress('')
      } else {
        toast.warning('Pesan gagal terkirim, silahkan coba beberapa saat lagi.')
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }

  }

  return (<div>
    {loading && (<div className='fixed z-50 left-0 right-0 top-0 bottom-0 backdrop-grayscale backdrop-blur-sm flex items-center justify-center'> <div className='w-16 h-16 bg-white border relative rounded-xl flex items-center justify-center'> <BiMailSend fontSize={22} className='text-primary' /> <AiOutlineLoading3Quarters className='text-5xl animate-spin text-primary absolute' /> </div> </div>
    )}

    <div className='min-h-screen lg:flex flex-warp'>
      <div className='w-full lg:w-1/2 relative'>
        <img
          className="w-full h-full object-cover"
          src="/images/quet.png"
          alt="service"
        />

        <div className='absolute left-0 right-0 top-0 bottom-0 p-4 md:p-16 text-white'>
          <div className='flex gap-10'>
            {packageList?.map(item => (
              <div
                key={item.id}
                onClick={() => handleChangeService(item)}
                className={`${item.title === activeBtn
                  ? 'ring-2 ring-white'
                  : 'opacity-60 hover:opacity-100'
                  }`}
              />
            ))}
          </div>
        </div>
      </div>

      <div className='w-full lg:w-1/2 bg-white py-8 px-4 md:px-8 xl:px-12'>
        <h2 className='text-[#006c63] text-[35px] font-[500] mb-[32px]'>
          Katakan pada kami <br />kebutuhan Anda!
        </h2>

        <div>
          <InputCustom
            onChange={e => setName(e.target.value)}
            value={name}
            placeholder='Name'
            type='text'
            name='name'
            id='name'
          />

          <div className='mb-[20px]' />

          <div className='grid gap-4 md:grid-cols-2'>
            <InputCustom
              onChange={e => setEmail(e.target.value)}
              icon={<BiEnvelope />}
              placeholder='Email'
              type='email'
              name='email'
              id='email'
              value={email}
            />

            <InputCustom
              icon={<MdOutlineCall />}
              onChange={e => setPhone(e.target.value)}
              placeholder='Phone Number'
              type='number'
              name='phone'
              id='phone'
              value={phone}
            />
          </div>

          <div className='mb-[20px]' />

          <InputCustom
            icon={<BiMap />}
            placeholder='Address'
            onChange={e => setAddress(e.target.value)}
            type='text'
            name='address'
            id='address'
            value={address}
          />

          <div className='mb-[20px]' />

          <InputCustom
            placeholder='Saya tertarik untuk order servis Videowall...'
            type='text'
            name='message'
            id='message'
            value={message}
            isLongText
            onChange={e => setMessage(e.target.value)}
          />

          <div className='mb-[20px]' />

          <div className='flex text-[#7C7C7C] items-start gap-2'>
            <input type='checkbox' id='agree' className='mt-1 cursor-pointer' />
            <label htmlFor='agree' className='flex-1 text-[12px] leading-[20px] cursor-pointer'>
              Dengan mengirimkan pesan ini, Anda setuju dengan penjelasan
              tentang informasi yang dikumpulkan. Kami akan membalas pesan
              Anda sesegera mungkin melalui email atau WhatsApp.
            </label>
          </div>

          <div className='mb-[20px]' />

          <div className='flex justify-end'>
            <button
              onClick={handleSubmit}
              className='w-[120px] shadow-lg h-[40px] bg-[#006c63] rounded-[5px] text-white font-semibold'
            >
              Send
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>


  )
}

export default RequestList
